import React from 'react'

function ChevronRight({
  className,
  fill,
  onClick,
  size
}) {
  return (
    <div className={className} onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" className={!size ? "h-5 w-5" : size} viewBox="0 0 20 20" fill={fill}>
        <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
      </svg>
    </div>
  )
}

export default ChevronRight
